import React, { memo } from 'react';
import Skeleton from './Skeleton';

export const UserProfileSkeleton = memo(function UserProfileSkeleton({ style = {} }) {
  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px 16px', ...style }} aria-busy="true">
      {/* Header Profile Hero Card */}
      <div
        style={{
          background: '#FFFFFF',
          borderRadius: 14,
          border: '1.5px solid var(--border, #E5E7EB)',
          padding: 24,
          marginBottom: 24,
          display: 'flex',
          alignItems: 'center',
          gap: 20,
        }}
      >
        <Skeleton variant="circular" width={80} height={80} />
        <div style={{ flex: 1 }}>
          <Skeleton variant="text" width={200} height={24} style={{ marginBottom: 8 }} />
          <Skeleton variant="text" width={140} height={14} style={{ marginBottom: 12 }} />
          <div style={{ display: 'flex', gap: 10 }}>
            <Skeleton variant="rectangular" width={90} height={22} borderRadius={12} />
            <Skeleton variant="rectangular" width={110} height={22} borderRadius={12} />
          </div>
        </div>
      </div>

      {/* Form / Details Grid */}
      <div
        style={{
          background: '#FFFFFF',
          borderRadius: 14,
          border: '1.5px solid var(--border, #E5E7EB)',
          padding: 24,
        }}
      >
        <Skeleton variant="text" width={180} height={20} style={{ marginBottom: 20 }} />

        <div className="grid-1-2" style={{ gap: 20, marginBottom: 20 }}>
          <div>
            <Skeleton variant="text" width={100} height={12} style={{ marginBottom: 8 }} />
            <Skeleton variant="rectangular" width="100%" height={40} borderRadius={9} />
          </div>
          <div>
            <Skeleton variant="text" width={100} height={12} style={{ marginBottom: 8 }} />
            <Skeleton variant="rectangular" width="100%" height={40} borderRadius={9} />
          </div>
        </div>

        <div className="grid-1-2" style={{ gap: 20, marginBottom: 20 }}>
          <div>
            <Skeleton variant="text" width={100} height={12} style={{ marginBottom: 8 }} />
            <Skeleton variant="rectangular" width="100%" height={40} borderRadius={9} />
          </div>
          <div>
            <Skeleton variant="text" width={100} height={12} style={{ marginBottom: 8 }} />
            <Skeleton variant="rectangular" width="100%" height={40} borderRadius={9} />
          </div>
        </div>

        <div style={{ marginBottom: 24 }}>
          <Skeleton variant="text" width={120} height={12} style={{ marginBottom: 8 }} />
          <Skeleton variant="rectangular" width="100%" height={80} borderRadius={9} />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <Skeleton variant="rectangular" width={120} height={42} borderRadius={9} />
        </div>
      </div>
    </div>
  );
});

export default UserProfileSkeleton;
